module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"distance":"Distance","duration":"Duration","end":"End","start":"Start"},"de":{"distance":"Distanz","duration":"Dauer","end":"Ende","start":"Start"},"fr":{"distance":"Distance","duration":"Durée","end":"Fin","start":"Début"},"it":{"distance":"Distanza","duration":"Durata","end":"Fine","start":"Inizio"}}')
  delete Component.options._Ctor
}
